import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';
import { Dropdown, Menu, Modal } from 'antd';
import {
  UserOutlined,
  StarOutlined,
  CreditCardOutlined,
  RollbackOutlined,
  SendOutlined,
  LogoutOutlined,
  ScheduleOutlined,
} from '@ant-design/icons';

const HeaderProfile = ({
  profile,
  session,
  networkError,
  logout,
  getProfile,
}) => {

  const loadContents = () => {
    (profile.status === "init") && getProfile();
  };

  useEffect(() => {
    loadContents();
  }, []);

  useEffect(() => {
    if (networkError === false) { // coming out of a network error
      loadContents();
    }
  }, [networkError]);


  const { profile: coreProfile, status } = profile;
  const { email = "..." } = coreProfile;

  const productSupport = () => {
    Modal.info({
      title: 'Product support',
      content: (
        <div>
          Drop us a mail at support@pagehits.io and someone will get back to you within 24 business hours.
        </div>
      ),
      onOk() {},
    });
  };

  const dropMenu = (
    <Menu className="appbar__header__dropdown">
      <Menu.Item>
        <Link to="/user/profile">
          <UserOutlined />
          <span className="ml-2">My Profile</span>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/user/plan">
          <StarOutlined />
          <span className="ml-2">My Plan</span>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/user/payment">
          <CreditCardOutlined />
          <span className="ml-2">Payment Methods</span>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/user/billing">
          <RollbackOutlined />
          <span className="ml-2">Billing History</span>
        </Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <Link to="/activities">
          <ScheduleOutlined />
          <span className="ml-2">Recent Activities</span>
        </Link>
      </Menu.Item>
      <Menu.Item onClick={productSupport}>
        <div>
          <SendOutlined />
          <span className="ml-2">Email Support</span>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={()=>logout()}>
        <div className="text-danger">
          <LogoutOutlined />
          <span className="ml-2">Logout</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const userCircle = (
    <div className="header__user_circle d-flex text-light justify-content-around align-items-center">
      { coreProfile && coreProfile.avatarInitials && coreProfile.avatarInitials.length > 0 ?
        coreProfile.avatarInitials :
        <UserOutlined />
      }
    </div>
  );

  return (
    <div className="d-flex align-items-center">

      <div className="d-none d-md-inline-block">
        <div className="mr-3 text-muted small">
          { email }
        </div>
      </div>

      <Dropdown overlay={dropMenu} trigger={['click']} placement="bottomRight">
        { userCircle }
      </Dropdown>

    </div>
  );
};

export default HeaderProfile;

//
// export default class HeaderProfile extends React.Component {
//
//   static propTypes = {
//     profile: PropTypes.object.isRequired,
//     session: PropTypes.object,
//     networkError: PropTypes.bool.isRequired,
//
//     logout: PropTypes.func.isRequired,
//     getProfile: PropTypes.func.isRequired,
//   };
//
//   componentDidMount() {
//     const { status, profile } = this.props.profile;
//     if (status === "init") {
//       this.props.getProfile();
//     }
//   }
//
//   componentDidUpdate(prevProps) {
//     if (prevProps.networkError && !this.props.networkError) {
//       this.props.getProfile();
//     }
//   }
//
//   productSupport = () => {
//     Modal.info({
//       title: 'Product support',
//       content: (
//         <div>
//           Drop us a mail at support@pagehits.io and someone will get back to you within 24 business hours.
//         </div>
//       ),
//       onOk() {},
//     });
//   };
//
//
//   onLogout = () => {
//     // eventGA({ category: 'authentication', action: 'logout' });
//     this.props.logout();
//   };
//
//   dropMenu = (
//     <Menu className="appbar__header__dropdown">
//       <Menu.Item>
//         <Link to="/user/profile">
//           <UserOutlined />
//           <span className="ml-2">My Profile</span>
//         </Link>
//       </Menu.Item>
//       <Menu.Item>
//         <Link to="/user/plan">
//           <StarOutlined />
//           <span className="ml-2">My Plan</span>
//         </Link>
//       </Menu.Item>
//       <Menu.Item>
//         <Link to="/user/payment">
//           <CreditCardOutlined />
//           <span className="ml-2">Payment Methods</span>
//         </Link>
//       </Menu.Item>
//       <Menu.Item>
//         <Link to="/user/billing">
//           <RollbackOutlined />
//           <span className="ml-2">Billing History</span>
//         </Link>
//       </Menu.Item>
//       <Menu.Divider />
//       <Menu.Item>
//         <Link to="/activities">
//           <ScheduleOutlined />
//           <span className="ml-2">Recent Activities</span>
//         </Link>
//       </Menu.Item>
//       <Menu.Item onClick={this.productSupport}>
//         <div>
//           <SendOutlined />
//           <span className="ml-2">Email Support</span>
//         </div>
//       </Menu.Item>
//       <Menu.Divider />
//       <Menu.Item onClick={this.onLogout}>
//         <div className="text-danger">
//           <LogoutOutlined />
//           <span className="ml-2">Logout</span>
//         </div>
//       </Menu.Item>
//     </Menu>
//   );
//   render() {
//     const { profile, status } = this.props.profile;
//
//     const userCircle = (
//       <div className="header__user_circle d-flex text-light justify-content-around align-items-center">
//         { profile && profile.avatarInitials && profile.avatarInitials.length > 0 ?
//           profile.avatarInitials :
//           <UserOutlined />
//         }
//       </div>
//     );
//
//     const email = (status === "loaded") ? profile.email : null;
//
//     return (
//       <div className="d-flex align-items-center">
//
//         <div className="d-none d-md-inline-block">
//           <div className="mr-3 text-muted small">
//             { email }
//           </div>
//         </div>
//
//         <Dropdown overlay={this.dropMenu} trigger={['click']} placement="bottomRight">
//           { userCircle }
//         </Dropdown>
//
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./scripts/presentation/HeaderProfile.jsx